import PropTypes from 'prop-types';

// AddNewHospital.jsx
export default function AddHospitalModal({ newHospital, setNewHospital, handleAddHospital, handleCancelAddHospital, errors }) {
    return (
        <div className="modal modal-open">
            <div className="modal-box">
                <h3 className="font-bold text-lg mb-4">Add New Hospital</h3>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    handleAddHospital();
                }}>
                    {/* HospitalNameEN field */}
                    <div className="form-control">
                        <label className="label">
                            <span className="label-text">Hospital Name (EN)</span>
                        </label>
                        <input
                            type="text"
                            className={`input input-bordered ${errors.hospitalNameEN ? 'input-error' : ''}`}
                            value={newHospital.hospitalNameEN || ''} // ใส่ default value เป็นสตริงว่าง
                            onChange={(e) => setNewHospital({ ...newHospital, hospitalNameEN: e.target.value })}
                        />
                        {errors.hospitalNameEN && <span className="text-error text-sm">{errors.hospitalNameEN}</span>}
                    </div>

                    {/* HospitalNameTH field */}
                    <div className="form-control">
                        <label className="label">
                            <span className="label-text">Hospital Name (TH)</span>
                        </label>
                        <input
                            type="text"
                            className={`input input-bordered ${errors.hospitalNameTH ? 'input-error' : ''}`}
                            value={newHospital.hospitalNameTH || ''} // ใส่ default value เป็นสตริงว่าง
                            onChange={(e) => setNewHospital({ ...newHospital, hospitalNameTH: e.target.value })}
                        />
                        {errors.hospitalNameTH && <span className="text-error text-sm">{errors.hospitalNameTH}</span>}
                    </div>

                    {/* HospitalEmail field */}
                    <div className="form-control mt-4">
                        <label className="label">
                            <span className="label-text">Hospital Email</span>
                        </label>
                        <input
                            type="text"
                            className={`input input-bordered ${errors.hospitalEmail ? 'input-error' : ''}`}
                            value={newHospital.hospitalEmail || ''} // ใส่ default value เป็นสตริงว่าง
                            onChange={(e) => setNewHospital({ ...newHospital, hospitalEmail: e.target.value })}
                        />
                        {errors.hospitalEmail && <span className="text-error text-sm">{errors.hospitalEmail}</span>}
                    </div>
                    {/* Action buttons */}
                    <div className="modal-action">
                        <button type="submit" className="btn btn-primary">Add User</button>
                        <button type="button" className="btn" onClick={handleCancelAddHospital}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
AddHospitalModal.propTypes = {
    newHospital: PropTypes.object.isRequired,
    setNewHospital: PropTypes.func.isRequired,
    handleAddHospital: PropTypes.func.isRequired,
    handleCancelAddHospital: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
};
